'use client';
import React from 'react';

import { useTranslations } from 'next-intl';
import { useLocale } from 'next-intl';

import { shouldBeCompactItem } from './utils';
import ArticleItem from '@/ui/components/ArticleItem';
import { urlBuilder } from '@/utils/urlBuilder';

/**
 * @todo pagination
 */
export default function ArticlesList({ articles }) {
  const translate = useTranslations();
  const locale = useLocale();

  if (!articles.length) {
    return <p>{translate('category-nothing')}</p>;
  }

  return (
    <div>
      {articles.map(article => {
        const compact = shouldBeCompactItem(article);

        return (
          <ArticleItem
            key={article.id}
            href={urlBuilder({ item: article, locale })}
            imgSrc={article.media.image.thumbnail}
            imgAlt={article.title}
            title={article.title}
            description={article.content}
            buttonLabel={translate('category-button')}
            buttonIcon="file-lines"
            compact={compact}
            item={article}
          />
        );
      })}
    </div>
  );
}
